import React, { useState } from 'react';
import { Modal, Collapse } from "react-bootstrap";
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import NativeSelect from '@mui/material/NativeSelect';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { TextField } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import dayjs from 'dayjs';
// import TextareaAutosize from "@mui/base/TextareaAutosize";
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
// import Collapse from '@mui/material/Collapse';
import { computeAssignmentStatus, trackingSeasonLabel, isWorkflowComplete, isBucketAssigned } from '../utils/assignmentStatus';
import { priorSeasonKey } from './auditRowKey';
import { colSx, stickyBodySx, truncateSx, DRIFT_CELL_SX } from './auditColumns';

const BUCKET_STATUS_CHIP = {
  UNASSIGNED: { label: 'Unassigned', color: 'default' },
  NEEDS_ASSIGNMENT: { label: 'Assign bucket', color: 'warning' },
  WILL_SET: { label: 'Will set', color: 'info' },
  AGREES: { label: 'Agrees', color: 'success' },
  MISMATCH: { label: 'Mismatch', color: 'error' },
  UNMAPPED: { label: 'Needs mapping', color: 'warning' },
};


export default function AuditRow(props) {

  const { sKey, comCode, comID, facilityName, facilityId, seasonID, seasonName, seasonDateS, seasonDateE, seasonDesc, priorYearSeasonId, priorYearSeasonName, priorSeasonId, priorSeasonName, ProgramType,
    TrackingYear, added, accepted, OrigFacilityName, OrigFacilityId, OrigPriorYearSeasonId, OrigPriorYearSeasonName, OrigPriorSeasonId, OrigPriorSeasonName, OrigSeasonDateE, OrigSeasonDateS,
    OrigSeasonDesc, OrigSeasonName, OrigSeasonID, OrigAdded, OrigAccepted } = props.seasonData; //destructuring!

  const dim_facilityID = props.dim_facilityID;
  // const seasonDataForQueries = props.seasonDataForQueries;

  const deleteSqlRow = props.deleteSqlRow;
  const addOrUpdateSQLRow = props.addOrUpdateSQLRow;

  const handleUpdateLocationDimFacility = props.handleUpdateLocationDimFacility;

  const [isToggled, setToggle] = useState(false);

  const [showDescription, setShowDescription] = useState(false);
  const handleShowDescription = () => setShowDescription(true);
  const handleCloseDescription = () => setShowDescription(false);

  const [showLocationNotes, setShowLocationNotes] = useState(false);
  const handleCloseLocationNotes = () => setShowLocationNotes(false);
  const handleShowLocationNotes = () => setShowLocationNotes(true);

  const handleLocationNotesChanged = (event) => {
    const newNotes = event.target.value;
    // console.log("newNotes", newNotes)
    setLocationNotes(newNotes);
  };

  const [showPriorSeasons, setShowPriorSeasons] = useState(false);
  const handleClosePriorSeasons = () => setShowPriorSeasons(false);
  const handleShowPriorSeasons = () => setShowPriorSeasons(true);


  const [checkedAdded, setCheckedAdded] = useState(added);
  const [checkedAccepted, setCheckedAccepted] = useState(accepted);
  const [ProgramTypeControl, setProgramTypeControl] = useState(props.seasonData.ProgramType);
  const [TrackingSeasonControl, setTrackingSeasonControl] = useState(props.seasonData.TrackingSeason);
  const [TrackingYearControl, setTrackingYearControl] = useState(props.seasonData.TrackingYear);

  // --- Franchise Bucket (AUD-3/4/5) ---
  // The bucket is just another edited field on this row. It is submitted with
  // Add/Update, which is the SINGLE persistence operation for the whole row --
  // there is no separate assign call, and no notion of "this row must exist first".
  const bucketsByKey = props.bucketsByKey || {};
  const bucketKey = `${comCode}|${TrackingYear}`;
  const bucketEntry = bucketsByKey[bucketKey];
  const [seasonSequenceControl, setSeasonSequenceControl] = useState(props.seasonData.season_sequence ?? "");
  const [saveError, setSaveError] = useState("");

  const [locationNotes, setLocationNotes] = useState(props.locationNotes);
  const [priorSeasonArray, setPriorSeasonArray] = useState(props.priorSeasonArray);

  const handleUpdateLocationNotes = (e) => {
    // console.log("clicked update location notes")
    const locationRowData = {
      dim_facilityID: dim_facilityID,
      locationLKSINotes: locationNotes
    };
    handleUpdateLocationDimFacility(locationRowData)
  }


  const handleDeleteRow = async (sKey) => {

    console.log("handleDeleteRow called in SeasonRowComponent");

    const deletionpromise = await deleteSqlRow(sKey);
    console.log("deletion promise returned: ", deletionpromise);

    setCheckedAccepted(false);

  };


  // THE single persistence operation for this row: metadata + bucket, one call, one
  // backend transaction. On failure NOTHING was written, so we keep every local edit
  // exactly as the user left it and surface the reason -- they fix the bucket (or
  // whatever the server objected to) and click again.
  const handleAddOrUpdateRow = async (rowData) => {
    setSaveError("");
    try {
      const stored = await addOrUpdateSQLRow(rowData);
      setCheckedAccepted(true);
      // Render what the database actually holds, not what we submitted. They differ on
      // a DERIVE (an empty Tracking Season is filled from the bucket's mapping) and the
      // controls would otherwise keep showing the pre-save blank. `!= null` on purpose:
      // a genuinely null stored value means "still unset", which the control already shows.
      if (stored) {
        if (stored.trackingseason != null) setTrackingSeasonControl(String(stored.trackingseason));
        if (stored.trackingyear != null) setTrackingYearControl(String(stored.trackingyear));
        if (stored.season_sequence != null) setSeasonSequenceControl(stored.season_sequence);
      }
    } catch (err) {
      // Do NOT touch local state here: the request was atomic and rolled back, so the
      // form still represents unsaved intent. Resetting it would discard the user's work
      // and hide the fact that nothing saved.
      setSaveError(err && err.message ? err.message : 'save failed');
    }
  };


  const handleAddedChange = (event, sKey) => {

    console.log("handleAddedChange event :", event.target.checked);

    const newSetting = event.target.checked;

    setCheckedAdded(newSetting);
    setCheckedAccepted(false)

  };

  const handleProgramTypeChange = (event, sKey) => {

    const newSetting = ((event.target.value) ? event.target.value : 0)
    console.log("program change value from change: ", event.target.value)
    console.log(newSetting)
    setProgramTypeControl(newSetting);

    setCheckedAccepted(false)

  };

  const handleTrackingSeasonChange = (event, sKey) => {

    const newSetting = event.target.value
    setTrackingSeasonControl(newSetting);

    setCheckedAccepted(false)

  };

  const handleTrackingYearChange = (event, sKey) => {

    const newSetting = event.target.value
    setTrackingYearControl(newSetting);

    setCheckedAccepted(false)

  };

  // Picking a bucket is a local edit, exactly like changing Tracking Season. It writes
  // nothing on its own; the selection is submitted with Add/Update. A Mismatch is a
  // legitimate, logged stewardship choice, so nothing here suppresses it -- the chip
  // shows the state and the server records it.
  const handleBucketChange = (event) => {
    const raw = event.target.value;
    if (raw === "") { setSeasonSequenceControl(""); setCheckedAccepted(false); return; }
    const sel = Number(raw);
    const bucket = (bucketEntry?.buckets || []).find((b) => Number(b.season_sequence) === sel);
    if (!bucket) return;
    if (bucket.maps_to_trackingseason === null || bucket.maps_to_trackingseason === undefined) return; // unmapped, not assignable

    setSeasonSequenceControl(sel);
    setCheckedAccepted(false); // an unsaved edit, same as every other control on this row
  };

  const handleSeasonIDClicked = (event) => {


    const query = "Season/edit/" + seasonID + "/";
    const tabValue = "settings";

    const url = new URL('https://apps.daysmartrecreation.com/dash/admin');

    url.searchParams.set('Action', query);
    url.searchParams.set('tab', tabValue);

    const urlString = url.toString();


    console.log("urlString: ", urlString)

    window.open(urlString);

  };

  const priorSeasons = priorSeasonArray.map((seasonObj) => {

    const transformed =
    {
      TrackingSeason: seasonObj.TrackingSeason,
      TrackingYear: seasonObj.TrackingYear,
      comCode: seasonObj.comCode,
      seasonName: seasonObj.seasonName,
      seasonID: seasonObj.seasonID,
      facilityName: seasonObj.facilityName,
      seasonDateS: seasonObj.seasonDateS,
      seasonDateE: seasonObj.seasonDateE,
      comCode: seasonObj.comCode
    }


    return transformed;
  })

  // console.log("priorSeasons array!!!!", priorSeasons);

  const priorSeasonHtml = priorSeasons.map((pseasonObj) => {

    const pseason = {
      seasonID: pseasonObj.seasonID,
      seasonName: pseasonObj.seasonName,
      TrackingSeason: pseasonObj.TrackingSeason,
      TrackingYear: pseasonObj.TrackingYear,
      comCode: pseasonObj.comCode,
      seasonDateS: pseasonObj.seasonDateS,
      seasonDateE: pseasonObj.seasonDateE,
      facilityName: pseasonObj.facilityName
    }

    const transformed = (
      <PriorSeasonsTextArea key={priorSeasonKey(pseason)} pseason={pseason} />
    )
    
    // console.log("transformed within priorSeasonHTML", pseason);
    return transformed;

  })


  const seasonRowData = {
    sKey: sKey,
    com_code: comCode,
    comID: comID,
    facilityName: facilityName,
    facilityId: facilityId,
    seasonID: seasonID,
    seasonName: seasonName,
    seasonDateS: seasonDateS,
    seasonDateE: seasonDateE,
    seasonDesc: seasonDesc,
    priorYearSeasonId: priorYearSeasonId,
    priorYearSeasonName: priorYearSeasonName,
    priorSeasonId: priorSeasonId,
    priorSeasonName: priorSeasonName,
    programType: ProgramTypeControl,
    trackingYear: TrackingYearControl,
    trackingSeason: TrackingSeasonControl,
    added: checkedAdded,
    accepted: checkedAccepted,
    // The bucket travels with the row. "" (nothing selected) means "no bucket work" --
    // the parent omits the property entirely so the backend leaves any stored
    // assignment alone. Clearing an assignment is not a supported operation.
    season_sequence: seasonSequenceControl,
  }

// console.log("priorSeasonHtml", priorSeasonHtml)

  // Option A fix: a saved row that has drifted from the warehouse (any Orig*
  // marker set by Audit.js mergeLists) must surface Add/Update for re-review,
  // even if `checkedAccepted` didn't re-sync to the merged prop. Purely
  // presentational -- this drives ONLY the chip + action button below; it
  // triggers no write. The DB `accepted` stays true until an explicit
  // Add/Update (which writes accepted:true) or Delete.
  // Facility drift is judged by IDENTITY, not name. OrigFacilityId (a change in the
  // canonical facility_id -> the season moved to a different facility) IS a drift signal.
  // OrigFacilityName is intentionally EXCLUDED: a facility rename (same id) is surfaced as
  // context only (the expander "saved value") and must NOT force reacceptance -- owners
  // rename facilities frequently and the season still belongs to the same facility.
  // Presence test, NOT truthiness: an Orig* marker records the pre-drift value, which
  // can legitimately be 0 or "" (e.g. a legacy id). `||` would drop those (Boolean(0) is
  // false), masking a real drift -- exactly how a reset `accepted` once hid behind a
  // "Saved" chip. A marker is present iff the field is defined.
  const hasWarehouseDrift = [
    OrigFacilityId, OrigSeasonName, OrigSeasonDateS, OrigSeasonDateE,
    OrigSeasonDesc, OrigSeasonID, OrigPriorYearSeasonId, OrigPriorYearSeasonName,
    OrigPriorSeasonId, OrigPriorSeasonName
  ].some((v) => v !== undefined);
  const rowIsSaved = checkedAccepted && !hasWarehouseDrift;

  // Reviewed column (DISPLAY ONLY): three labels derived from state that ALREADY exists --
  //   Reviewed               = accepted & no drift
  //   Needs Review - New     = never accepted, no drift (expected first-time work)
  //   Needs Review - Drifted = a warehouse field drifted since acceptance (mergeLists reset
  //                            `accepted`; the red drift cell continues to reinforce this)
  // No new state or logic: rowIsSaved and hasWarehouseDrift are unchanged.
  const reviewedChip = rowIsSaved
    ? { label: 'Reviewed', color: 'success' }
    : hasWarehouseDrift
      ? { label: 'Needs Review — Drifted', color: 'warning' }
      : { label: 'Needs Review — New', color: 'default' };

  // Status work queue -- SINGLE SOURCE OF TRUTH. Computed from the parent's
  // persisted row (props.seasonData), the SAME inputs the AuditList Status filter
  // uses, so the chip and the filter can never disagree (a row that renders
  // "Complete" is guaranteed not to pass the "Needs Work" filter). Do NOT use this
  // row's local edit state here -- that was the divergence bug. The parent merges the
  // authoritative save response into mergedData, so this reflects stored state
  // without a reload.
  const statusComplete = isWorkflowComplete(props.seasonData.accepted, props.seasonData.season_sequence);

  // --- Franchise Bucket cell rendering (computed each render) ---
  const selectedBucket = (bucketEntry?.buckets || []).find((b) => Number(b.season_sequence) === Number(seasonSequenceControl));
  const derivedMapsTo = selectedBucket ? selectedBucket.maps_to_trackingseason : null;
  const hasCalendar = (bucketEntry?.buckets || []).some((b) => b.is_active);
  const noSelection = !isBucketAssigned(seasonSequenceControl);
  let bucketStatus = 'UNASSIGNED';
  if (!noSelection && selectedBucket) {
    // Judged against the LIVE edited Tracking Season, because that is the value this
    // row will submit and the value the backend will classify against. Reading the
    // persisted prop here would preview a Mismatch for an edit that will actually Agree.
    bucketStatus = computeAssignmentStatus(TrackingSeasonControl, selectedBucket.maps_to_trackingseason).status;
  } else if (hasCalendar && noSelection) {
    // A Franchise Calendar exists but nothing is assigned yet -> actionable to-do.
    // Louder than grey "Unassigned" so it isn't missed.
    bucketStatus = 'NEEDS_ASSIGNMENT';
  }
  const bucketStatusChip = BUCKET_STATUS_CHIP[bucketStatus] || BUCKET_STATUS_CHIP.UNASSIGNED;

  let bucketCell;
  if (!bucketEntry) {
    bucketCell = <Typography variant="caption" color="text.secondary">…</Typography>;
  } else if ((bucketEntry.buckets || []).length === 0) {
    bucketCell = <Typography variant="caption" color="warning.main">No Franchise Calendar</Typography>;
  } else {
    const bucketOptions = [...bucketEntry.buckets]
      .filter((b) => b.is_active)
      .sort((a, b) => a.season_sequence - b.season_sequence)
      .map((b) => {
        const unmapped = b.maps_to_trackingseason === null || b.maps_to_trackingseason === undefined;
        return (
          <option key={b.season_sequence} value={b.season_sequence} disabled={unmapped}>
            {b.sequence_name}{unmapped ? ' (needs mapping)' : ''}
          </option>
        );
      });
    bucketCell = (
      <NativeSelect
        value={noSelection ? "" : String(seasonSequenceControl)}
        onChange={handleBucketChange}>
        {/* The blank option is offered only while nothing is chosen. Once a bucket is
            selected there is no way to un-choose it, because clearing an assignment is
            not a supported operation -- the backend ignores an omitted season_sequence
            and keeps the stored one. Offering "—" on an assigned row would show a blank
            that silently does nothing on save. Switching buckets is always allowed. */}
        {noSelection && <option value="">—</option>}
        {bucketOptions}
      </NativeSelect>
    );
  }

  return (
    <>
      {/* <TableRow onClick={() => setToggle(!isToggled)}> */}
      <TableRow >
        {/* <StyledTableCell align="center" >{sKey}</StyledTableCell> */}

        <StyledTableCell sx={stickyBodySx('expander')}>
          <IconButton size="small" onClick={() => setToggle(!isToggled)} aria-label="expand row">
            {isToggled ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
          </IconButton>
        </StyledTableCell>

        <StyledTableCell align="center" sx={stickyBodySx('comCode')}>{comCode}</StyledTableCell>

        <StyledTableCell align="center" title={facilityName} sx={{ ...stickyBodySx('facility'), ...truncateSx, ...(OrigFacilityId !== undefined ? DRIFT_CELL_SX : {}) }}>
          <Button variant="Link" onClick={handleShowLocationNotes}>
            {facilityName}
          </Button>
          <Modal show={showLocationNotes} onHide={handleCloseLocationNotes}>
            <Modal.Header closeButton>
              <Modal.Title> {facilityName} Notes </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <LocationNotesTextArea
                defaultValue={locationNotes}
                onChange={handleLocationNotesChanged}>

              </LocationNotesTextArea>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleUpdateLocationNotes}>
                Update
              </Button>
              <Button variant="secondary" onClick={handleCloseLocationNotes}>
                Close
              </Button>

            </Modal.Footer>
          </Modal>

        </StyledTableCell>

        <StyledTableCell align="center" onClick={handleSeasonIDClicked} sx={colSx('seasonId')}>{seasonID}</StyledTableCell>
        <StyledTableCell align="center" title={seasonName} onClick={() => setToggle(!isToggled)} sx={{ ...colSx('seasonName'), ...truncateSx, ...(OrigSeasonName != undefined ? DRIFT_CELL_SX : {}) }}>{seasonName}</StyledTableCell>
        <StyledTableCell align="center" onClick={() => setToggle(!isToggled)} sx={{ ...colSx('startDate'), ...(OrigSeasonDateS != undefined ? DRIFT_CELL_SX : {}) }}>{seasonDateS ? dayjs(seasonDateS).format('MMM D, YYYY') : ''}</StyledTableCell>
        <StyledTableCell align="center" onClick={() => setToggle(!isToggled)} sx={{ ...colSx('endDate'), ...(OrigSeasonDateE != undefined ? DRIFT_CELL_SX : {}) }}>{seasonDateE ? dayjs(seasonDateE).format('MMM D, YYYY') : ''}</StyledTableCell>
        <StyledTableCell align="center" onClick={() => setToggle(!isToggled)} sx={{ ...colSx('priorSeason'), ...(OrigPriorSeasonName != undefined ? DRIFT_CELL_SX : {}) }}>{priorSeasonName}</StyledTableCell>
        <StyledTableCell align="center" onClick={() => setToggle(!isToggled)} sx={{ ...colSx('priorYearSeason'), ...(OrigPriorYearSeasonName != undefined ? DRIFT_CELL_SX : {}) }}>{priorYearSeasonName}</StyledTableCell>
        <StyledTableCell align="center" sx={colSx('programType')}>

          <NativeSelect
            name="ProgramType"
            id="ProgramType"
            defaultValue={ProgramTypeControl}
            onChange={e => handleProgramTypeChange(e, { sKey })}>
            <option value="1">LK - 1</option>
            <option value="2" >SI - 2</option>
            <option value="0">Other</option>
          </NativeSelect>

        </StyledTableCell>

        <StyledTableCell align="center" sx={colSx('season')}>

          <NativeSelect
            name="TrackingSeason"
            id="TrackingSeason"
            defaultValue={TrackingSeasonControl}
            onChange={e => handleTrackingSeasonChange(e, { sKey })}>
            <option value="1">Spring</option>
            <option value="2">Summer</option>
            <option value="3">Fall</option>
            <option value="4">Winter</option>
            <option value="0">Other</option>
          </NativeSelect>

        </StyledTableCell>
        <StyledTableCell align="center" sx={colSx('year')}>

          <NativeSelect
            name="TrackingYear"
            id="TrackingYear"
            defaultValue={TrackingYearControl}
            onChange={e => handleTrackingYearChange(e, { sKey })}>
            <option value="2015">2015</option>
            <option value="2016">2016</option>
            <option value="2017">2017</option>
            <option value="2018">2018</option>
            <option value="2019">2019</option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
          </NativeSelect>

        </StyledTableCell>


        <StyledTableCell align="center" padding="checkbox" sx={colSx('lkOrSi')}>
          <Checkbox value={checkedAdded == 1} checked={checkedAdded == 1} onChange={e => handleAddedChange(e, { sKey })}></Checkbox>
        </StyledTableCell>

        <StyledTableCell align="center" sx={colSx('franchiseBucket')}>
          {bucketCell}
        </StyledTableCell>
        <StyledTableCell align="center" sx={colSx('bucketSeason')}>
          {trackingSeasonLabel(derivedMapsTo)}
        </StyledTableCell>
        <StyledTableCell align="center" sx={colSx('bucketStatus')}>
          <Chip label={bucketStatusChip.label} color={bucketStatusChip.color} size="small" />
        </StyledTableCell>

        <StyledTableCell align="center" sx={colSx('rowSaved')}>
          <Chip label={reviewedChip.label} color={reviewedChip.color} size="small" sx={{ minWidth: 72, '& .MuiChip-label': { whiteSpace: 'nowrap' } }} />
        </StyledTableCell>
        <StyledTableCell align="center" sx={colSx('status')}>
          {/* Status = the single-source statusComplete (parent row), identical to the
              AuditList filter's computation. See statusComplete above. */}
          <Chip
            label={statusComplete ? "Complete" : "Needs Work"}
            color={statusComplete ? "success" : "warning"}
            size="small"
            sx={{ minWidth: 96, '& .MuiChip-label': { whiteSpace: 'nowrap' } }} />
        </StyledTableCell>
        <StyledTableCell align="center" sx={colSx('action')}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25 }}>
            {rowIsSaved
              ? <Button variant="outlined" size="small" onClick={() => handleDeleteRow(sKey)}>Delete</Button>
              : <Button variant="contained" size="small" onClick={() => handleAddOrUpdateRow(seasonRowData)}>Add/Update</Button>}
            {/* Nothing was written when this is set -- the whole request rolled back --
                so the row still shows the user's unsaved edits, ready to retry. */}
            {saveError && (
              <Typography variant="caption" color="error.main" sx={{ whiteSpace: 'normal' }}>{saveError}</Typography>
            )}
          </Box>
        </StyledTableCell>


      </TableRow>
      <Collapse in={isToggled}>
        <TableRow>
          <StyledTableCell colSpan={19} sx={{ py: 2, px: 3, backgroundColor: 'action.hover' }}>

            {/* Section 1: always-visible reference fields */}
            <Box sx={{ display: 'grid', gridTemplateColumns: 'minmax(110px, auto) minmax(90px, auto) minmax(120px, auto) minmax(120px, auto) 1fr', gap: 3 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">Key</Typography>
                <Typography variant="body2">{sKey}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">Com ID</Typography>
                <Typography variant="body2">{comID}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">Facility ID</Typography>
                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>{facilityId || '—'}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">Prior Season ID</Typography>
                <Typography variant="body2">{priorSeasonId}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">PY Season ID</Typography>
                <Typography variant="body2">{priorYearSeasonId}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Typography variant="caption" color="text.secondary">Description</Typography>
                <Typography variant="body2">{seasonDesc || '—'}</Typography>
              </Box>
            </Box>

            {/* Section 2: saved values (before the warehouse update) — rendered when ANY Orig marker
                is present. PRESENCE test, not truthiness: an Orig marker records the pre-drift SAVED
                value, which can legitimately be "" or null — e.g. a blank -> populated drift, like a
                prior-year season the accepted baseline never had. Truthiness (&&) dropped those and
                hid the "before" entirely (a flagged cell with no saved-value detail); SavedValue now
                renders an empty/null original as "—" so the "before" is always shown. */}
            {[OrigFacilityId, OrigFacilityName, OrigSeasonName, OrigSeasonDateS, OrigSeasonDateE,
              OrigSeasonDesc, OrigPriorSeasonId, OrigPriorSeasonName, OrigPriorYearSeasonId,
              OrigPriorYearSeasonName].some((v) => v !== undefined) && (
              <>
                <Divider sx={{ my: 1.5 }} />
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  Saved values (before warehouse update)
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                  {OrigFacilityId        !== undefined && <SavedValue label="Facility ID saved value" value={OrigFacilityId} />}
                  {OrigFacilityName      !== undefined && <SavedValue label="Facility saved value (name)" value={OrigFacilityName} />}
                  {OrigSeasonName        !== undefined && <SavedValue label="Season Name saved value" value={OrigSeasonName} />}
                  {OrigSeasonDateS       !== undefined && <SavedValue label="Start Date saved value" value={OrigSeasonDateS ? dayjs(OrigSeasonDateS).format('MMM D, YYYY') : ''} />}
                  {OrigSeasonDateE       !== undefined && <SavedValue label="End Date saved value" value={OrigSeasonDateE ? dayjs(OrigSeasonDateE).format('MMM D, YYYY') : ''} />}
                  {OrigSeasonDesc        !== undefined && <SavedValue label="Description saved value" value={OrigSeasonDesc} />}
                  {OrigPriorSeasonId     !== undefined && <SavedValue label="Prior Season ID saved value" value={OrigPriorSeasonId} />}
                  {OrigPriorSeasonName   !== undefined && <SavedValue label="Prior Season Name saved value" value={OrigPriorSeasonName} />}
                  {OrigPriorYearSeasonId !== undefined && <SavedValue label="PY Season ID saved value" value={OrigPriorYearSeasonId} />}
                  {OrigPriorYearSeasonName !== undefined && <SavedValue label="PY Season Name saved value" value={OrigPriorYearSeasonName} />}
                </Box>
              </>
            )}

          </StyledTableCell>
        </TableRow>
      </Collapse>

    </>
  )
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


// One "saved value (before warehouse update)" field in the expander. A pre-drift SAVED value can
// legitimately be "" or null (a blank -> populated drift), so render those as "—" rather than
// dropping the field — otherwise a flagged cell shows no "before" at all.
export function SavedValue({ label, value }) {
  const isBlank = value === undefined || value === null || value === '';
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      <Typography variant="caption" color="warning.main">{label}</Typography>
      <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>{isBlank ? '—' : value}</Typography>
    </Box>
  );
}

const StyledTextArea = styled(TextareaAutosize)(
  ({ theme }) => `
  width: 90%;`
);

export function LocationNotesTextArea(props) {
  return (
    <StyledTextArea
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    ></StyledTextArea>
  );
}

export function PriorSeasonsTextArea(props) {

  const pseason = props.pseason;

  let seasonString = "";
  if (pseason.TrackingSeason === '1') 
  seasonString = "Spring";
  else if (pseason.TrackingSeason === '2')
  seasonString = "Summer"
  else if (pseason.TrackingSeason === '3')
  seasonString = "Fall"
  else if (pseason.TrackingSeason === '4')
  seasonString = "Winter"
  

  return (
    <div key={priorSeasonKey(pseason)}>
      <h6>Name: {pseason.seasonName}</h6>
      <p>Season: {seasonString}</p>
      <p>SeasonID: {pseason.seasonID}</p>
      <p>Year: {pseason.TrackingYear}</p>
      <p>ComCode: {pseason.comCode}</p>
      <p>Start: {pseason.seasonDateS}</p>
      <p>End: {pseason.seasonDateE}</p>
      <p>Location: {pseason.facilityName}</p>
      <p>---------------</p>
    </div>
  );
}

